<template>
  <div>
    <div v-for="question in sortedData" :key="`${question.q_id}`">
      <div class="card mb-0" @click="toggleCollapse(question.q_id)">
        <div class="card-body question-container">
          <div class="col-2">
            <span class="question-id">{{question.q_id}}</span>
          </div>
          <div class="col-10">
            <div class="d-flex flex-column question-text-wrapper">
              <span class="question-text">{{question.q_text}}</span>
              <span>{{question.question_type}}: {{getCategoricalValue(question.question_values, 2)}} {{question.question_values && question.question_values.length > 2 ? '...' : ''}}</span>
            </div>
          </div>
        </div>
      </div>
      <b-collapse id="collapse" :visible="openedQuestions.includes(question.q_id)">
        <div class="content-wrapper">
          <Loader :show="visibleLoaders.includes(question.q_id)" :fixed="false"/>
          <div class="values-container">
            <div class="value-row" v-for="(value, key) in getStats(questionData[question.q_id])" :key="`${question.q_id}-${key}`">
              {{key}}: {{value}}
            </div>
            <div class="value-row"
                 v-for="(value, key) in questionData[question.q_id] ? questionData[question.q_id].Answers : []" :key="`${question.q_id}-${key}`">
              {{key}}: {{value}}
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import studyActions from '../../store/modules/studies/actionTypes'
import studyGetters from '../../store/modules/studies/getterTypes'
import Loader from '../shared/Loader'

export default {
  name: 'CicsList',
  components: { Loader },
  props: {
    data: Array
  },
  data () {
    return {
      openedQuestions: [],
      visibleLoaders: [],
      questionData: {}
    }
  },
  computed: {
    ...mapGetters({
      filters: studyGetters.GET_CICS_FILTERS
    }),
    sortedData () {
      return this.data.length ? _.cloneDeep(this.data).sort((a, b) => a.score < b.score ? 1 : a.score > b.score ? -1 : 0) : []
    }
  },
  methods: {
    ...mapActions({
      getData: studyActions.FETCH_CICS_QUESTION_DATA
    }),
    toggleCollapse (index) {
      if (this.openedQuestions.includes(index)) {
        this.openedQuestions.splice(this.openedQuestions.indexOf(index), 1)
      } else {
        this.getQuestionData(index)
        this.openedQuestions.push(index)
      }
    },
    toggleLoader (index) {
      if (this.visibleLoaders.includes(index)) {
        this.visibleLoaders.splice(this.visibleLoaders.indexOf(index), 1)
      } else {
        this.visibleLoaders.push(index)
      }
    },
    getCategoricalValue (values, length) {
      const array = _.cloneDeep(values)
      if (!array) {
        return 'Not specified'
      }
      const sortedArray = array.sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
      if (length) {
        return sortedArray.splice(0, length).join(', ')
      }
      return sortedArray.join(', ')
    },
    getStats (obj) {
      const data = { ...obj }
      Object.keys(data).forEach(el => {
        typeof data[el] === 'object' && delete data[el]
      })
      return data
    },
    getQuery () {
      const data = {
        Country: null,
        Region: null,
        Region_new: null,
        Gender: this.filters.gender.value ? this.filters.gender.value : null
      }
      data[this.filters.geographicalType.value] = this.filters.geographicalValue.value
      data['Age'] = [this.filters.startAge.value || 0, this.filters.endAge.value || 99]
      return data
    },
    async getQuestionData (index) {
      this.toggleLoader(index)
      const data = this.getQuery()
      this.questionData[index] = await this.getData({ q: data, id: index })
      this.toggleLoader(index)
    }
  }
}
</script>

<style scoped>
.values-container {
  background-color: #f0f0f0;
  border-left: 1px solid #d1d4d7;
  border-right: 1px solid #d1d4d7;
  overflow-y: scroll;
  height: 280px;
}

.value-row {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid #d1d4d7;
}

.values-container .value-row:last-of-type {
  border-bottom: 0;
}

.question-id {
  font-size: 22px;
  color: #9d9fa5;
}

.question-container {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.question-text-wrapper {
  margin-left: 15px;
}

.question-text {
  font-size: 18px;
}

.content-wrapper {
  position: relative;
}
</style>
